import { useEffect } from 'react';
import { FormikProps } from 'formik';
import { useRouterHelper, useTranslation } from '@shared/core';
import { useContactCollectorGuestTelemetry } from '../../ContactCollectorGuest.telemetry';
import { contactCollectorGuestRoutePaths } from '../..';
import type { Contacts } from '../../shared/types';

export const useConfirmationController = (formik: FormikProps<Contacts>) => {
  const { buttonInteracted } = useContactCollectorGuestTelemetry();
  const routeHelpers = useRouterHelper();
  const { t } = useTranslation('contactCollector');
  const tAdmin = t('admin');

  useEffect(() => {
    if (!formik.isValid) {
      return routeHelpers.goToExactRoute(contactCollectorGuestRoutePaths.landing.path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnModifyDetailsClick = () => {
    buttonInteracted({ buttonType: 'edit', element: 'modifyDetails' });
    routeHelpers.goToExactRoute(contactCollectorGuestRoutePaths.form.path);
  };

  const handleOnLooksGoodClick = () => {
    buttonInteracted({ buttonType: 'save', element: 'looksGood' });
    formik.handleSubmit();
  };

  return {
    tAdmin,
    handleOnModifyDetailsClick,
    handleOnLooksGoodClick,
  };
};
